import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App';
import { initPolyfill } from './initPolyfill';
import { initializeStore } from './redux/store/store';
import { initializeSessionCookie } from './utils';
import { initializeLangtexts } from './resourceUtils';
import { loadUserInfoUnprotected } from './redux/actions/sessionActions';

initPolyfill();

let store = initializeStore();

initializeSessionCookie();
loadUserInfoUnprotected(false);

const renderInitializationError = (err: Object | string) => {
  render(
    <p>
      Při inicializaci došlo k vnitřní chybě aplikace:
      <br />
      {err.toString()}
    </p>,
    document.getElementById('page-root')
  );
};

const renderApplication = () => {
  render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('page-root')
  );
};

initializeLangtexts()
  .then(() => {
    renderApplication();
  })
  .catch((err) => {
    console.error('Application failed to initialize: ', err);
    renderInitializationError(err);
  });
